import { Box } from "@mui/material";
import "./styles.css";

type LoadingIconProps = {
  boxWidth?: string;
  boxHeight?: string;
};

export const LoadingIcon = ({ boxWidth = "100%", boxHeight = "100%" }: LoadingIconProps) => (
  <Box sx={{ width: boxWidth, height: boxHeight, display: "flex", justifyContent: "center", alignItems: "center" }}>
    <img className="logo" src="/img/barbell.png" alt="loading" />
  </Box>
);
